import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import Logout from "modules/User/Logout";
import { UPLOAD_OPERATION_NAMES } from "modules/Quotes/Pages/EditQuotes/upload/uploadFlags";

export const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, path }) => {
      console.error(`[GraphQL Error]: Message: ${message}, Path: ${path}`);
    });

  if (networkError) {
    if (networkError.message.slice(-3) === "401") {
      console.error(`[Network Error]: Message: ${networkError.message}`);
      // A 401 on one of the upload mutations must not navigate away: Logout() would kill every
      // in-flight part. Nothing else to do here either: the same 401 rejects the engine's own
      // client.mutate() promise, and the engine turns it into a terminal "sign in again" state.
      if (UPLOAD_OPERATION_NAMES.indexOf(operation.operationName) !== -1) return;
      Logout();
    } else {
      console.error(`[Network Error]: Message: ${networkError.message}`);
    }
  }
});

export const httpLink = createHttpLink({
  uri: process.env.REACT_APP_BASE_URL,
});

export const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization:
        localStorage?.token || sessionStorage?.token
          ? `Bearer ${
              localStorage?.token ? localStorage?.token : sessionStorage?.token
            }`
          : null,
    },
  };
});

export const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache(),
});
